<template>
    <div>
        <div class="card shadow">
            <div class="card-header bg-transparent">
                <div>
                    <h3 class="mb-0">
                        {{ $tc('message.payments',2) }}
                    </h3>
                </div>
            </div>

            <div class="card-body px-0">
                <div class="row">
                    <b-container>
                        <b-row>
                            <b-col col sm="12" class="px-0">
                                <section class="container px-0" id="appointment-table">
                                    <div class="appointment-table-header my-2 mb-4">
                                        <b-button @click="handleOnAddBill" v-if="can" class="my-1">
                                            <i class="fa fa-plus edit-icon"></i>
                                            {{ $t('message.add') }}
                                        </b-button>

                                        <div class="d-inline-block ml-1 mr-md-5 width-270">
                                            <b-input-group
                                                    size="sm"
                                                    class="mb-3"
                                            >
                                                <b-form-input
                                                        type="text"
                                                        size="sm"
                                                        class="p-2 h-100"
                                                        :placeholder="$t('message.filter') + '...'"
                                                        v-model="filterCriteria"
                                                ></b-form-input>
                                                <b-input-group-append>
                                                    <b-button
                                                            size="sm"
                                                            text="Button"
                                                            variant="primary"
                                                            @click="handlerOnFilterButton"
                                                    >
                                                        Go
                                                    </b-button>
                                                </b-input-group-append>
                                            </b-input-group>
                                        </div>
                                        <div class="row">
                                        <div class="col-4">
                                            <div class="ml-1">
                                                <div class="d-flex">
                                                   
                                                    <b-form-select
                                                            class="d-inline-block mr-2"
                                                            v-model="status"
                                                            size="sm"
                                                            :options="statusOptions"></b-form-select>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-8 overflow-auto">
                                            <div class="ml-1">
                                                <div
                                                        v-if="paginationObject.numOfPages > 1"
                                                        class="pagination-wrapper d-inline-block"
                                                >
                                                    <div class="pagination">
                                                        <a
                                                                href="#"
                                                                :class="'prev page-numbers ' + (
                                                        paginationObject.currentPageNumber === 1
                                                            ? 'pagination-disabled'
                                                            : ''
                                                        )"
                                                                @click="_handlePaginationClick('prev')"
                                                        >
                                                            <i aria-hidden="true" class="v-icon fas fa-chevron-left"></i>
                                                        </a>
                                                        <template v-for="(pageNumber, key) in paginationObject.listOfPageNumber()">
                                                            <template v-if="pageNumber === paginationObject.currentPageNumber">
                                                        <span
                                                                :key="key"
                                                                aria-current="page"
                                                                class="page-numbers current"
                                                        >
                                                            {{ pageNumber }}
                                                        </span>
                                                            </template>
                                                            <template v-else>
                                                                <a
                                                                        href="#"
                                                                        :key="key"
                                                                        class="page-numbers"
                                                                        @click="_handlePaginationClick(pageNumber)"
                                                                >
                                                                    {{ pageNumber }}
                                                                </a>
                                                            </template>
                                                        </template>
                                                        <a
                                                                href="#"
                                                                class="next page-numbers"
                                                                :class="'next page-numbers ' + (
                                                        paginationObject.currentPageNumber === paginationObject.numOfPages
                                                            ? 'pagination-disabled'
                                                            : ''
                                                        )"
                                                                @click="_handlePaginationClick('next')"
                                                        >
                                                            <i aria-hidden="true" class="v-icon fas fa-chevron-right"></i>
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    </div>
                                    <div class="row appointment-table-content">
                                        <div class="container-fluid">
                                            <template v-if="paginationObject.display(paginationObject.currentPageNumber).length > 0">
                                                <div
                                                    v-for="(bill, key) in paginationObject.display(paginationObject.currentPageNumber)"
                                                    :key="key"
                                                    class="row appointment-item"
                                                >
                                                    <div class="col-lg-3 px-0">
                                                            <span class="appointment-label">
                                                                {{ $t('message.dateFacturation') }}
                                                            </span>
                                                        <h4 class="appointment-date">{{ billDate(bill.date_facturation, 'date') }}</h4>
                                                        <span class="appointment-label">
                                                                {{ $t('message.time') }}
                                                            </span>
                                                        <h4 class="appointment-hour">{{ billDate(bill.date_facturation, 'hour') }}</h4>
                                                    </div>
                                                    <div class="col-lg-3 px-0">
                                                        <span class="appointment-label">
                                                            {{ $t('message.nomPatient') }}
                                                        </span>
                                                        <h4
                                                                class="appointment-hour appointment-link"
                                                        >
                                                            {{ bill.patient }}
                                                        </h4>

                                                        <span class="appointment-label">
                                                            {{ $t('message.souscripteur') }}
                                                        </span>
                                                        <h4>{{ bill.souscripteur }}</h4>
                                                    </div>
                                                    <div class="col-lg-3 px-0">
                                                        <span class="appointment-label">
                                                            {{ $t('message.price') }}
                                                        </span>
                                                        <h4>{{ bill.prix }} FCFA</h4>
                                                        <div v-if="bill.status === 'PAYE'">
                                                            <span class="appointment-label">
                                                                {{ $t('message.datePayment') }}
                                                            </span>
                                                            <h4>{{ billDate(bill.date, 'date') }}</h4>
                                                        </div>
                                                    </div>
                                                    <div class="col-lg-3 px-0">
                                                        <span :class="'medsur-custom-badge inverted ' + getStatusClass(bill.status)">
                                                            {{ bill.status }}
                                                        </span>
                                                        <br>
                                                        <br>
                                                        <b-button
                                                            variant="primary"
                                                            class="mb-2"
                                                            size="sm"
                                                            @click="onShowBillClick(bill.uuid)"
                                                            v-if="bill.status === 'NON PAYE'">
                                                            {{ $t('message.paymentLink') }}
                                                        </b-button>
                                                        <b-button
                                                            variant="outline-primary"
                                                            size="sm"
                                                            class="mb-2"
                                                            @click="onEditBillClick(bill.uuid)">
                                                            {{ $t('message.edit') }}
                                                        </b-button>
                                                        <b-button
                                                            v-if="bill.status === 'NON PAYE'"
                                                            variant="outline-danger"
                                                            size="sm"
                                                            class="mb-2"
                                                            @click="onDeleteBillClick(bill.uuid)">
                                                            {{ $t('message.delete') }}
                                                        </b-button>                                                        
                                                    </div>
                                                    <span
                                                            class="appointment-item-status-mobile --danger"
                                                            :class="'appointment-item-status-mobile ' + getStatusClass(bill.status)"
                                                    >
                                                            <span class="badge badge-success">
                                                                {{bill.status}}
                                                            </span>
                                                        </span>
                                                </div>
                                            </template>

                                            <template v-else>
                                                <h4>{{ $t('message.noItemToDisplay') }}</h4>
                                            </template>

                                        </div>
                                    </div>
                                    <div class="row appointment-table-footer">

                                    </div>
                                </section>
                            </b-col>
                        </b-row>
                    </b-container>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import _ from "lodash";
    import Swal from 'sweetalert2';
    import moment from "moment";
    import { pagination, handlePaginationClick } from "../../helpers/paginations";
	import { displayNumber } from "../../helpers/general";

    export default {
        name: "List",

        computed: {
            ...mapGetters(['hasAdminRole',"payments",
                'hasGestionnaireRole','hasMedecinControleRole','hasSouscripteurRole','isComptable','hasAssistante']),

            can: function () {
                return this.hasAdminRole || this.hasGestionnaireRole || this.hasMedecinControleRole || this.isComptable || this.hasAssistante;
            },
            order:function () {
                return this.payments;
            },

            paymentColumns: function () {
                return [

                    {
                        label: this.$i18n.t('message.souscripteur'),
                        field: 'souscripteur',
                    },
                    {
                        label: this.$i18n.t('message.patient'),
                        field: 'patient',
                    },
                    {
                        label: this.$i18n.t('message.amount'),
                        field: 'prix',
                    },
                    {
                        label: this.$i18n.t('message.datePayment'),
                        field: 'date',
                    },
                    {
                        label: this.$i18n.t('message.status'),
                        field: 'status',
                    }
                ];
            },
        },

        data(){
            return {
                paginationOptions: {
                    enabled: true,
                    mode: 'records',
                    perPageDropdown: [3, 6, 10]
                },
                bills: [],
                statusOptions:[
                    {
                    value: 1,
                    text: 'Tous'
                    },
                    {
                    value: 'PAYE',
                    text: 'Payé'
                    },
                    {
                    value: 'NON PAYE',
                    text: 'Non payée'
                    },
                ],
                status:null,
                filterCriteria: '',
                paginationObject: {},
                lien: window.location.origin+"/payment-prestation/"
            }
        },

        watch: {

            bills: function (newValue, oldValue) {                
                this.paginationObject = pagination(newValue);
            },

            filterCriteria: function (newValue, oldValue) {
                this.handleFilter(newValue);
            },
            status: function (newValue, oldValue) {

                    let newCurrentPatientArray = [];
                     newCurrentPatientArray = this.bills.filter((subElement) => subElement.status === newValue)
                    this.paginationObject = pagination(newCurrentPatientArray);
                if (newValue === 1){
                   this.paginationObject = pagination(this.bills);
                }
            },
            payments: function() {
                let fArray = [];

                _.forEach(this.payments, function(payment) {
                    let f = {};
                        if(payment.souscripteur){
                            if(payment.souscripteur.user){
                                if(payment.patients){
                                    console.log(payment);
                                    //let nom = facture.dossier.patient.user.nom + ' ' + (_.isNull(facture.dossier.patient.user.prenom) ? '' :facture.dossier.patient.user.prenom);
                                    f.souscripteur = payment.souscripteur.user.name;
                                    f.patient = payment.patients.user.name;
                                    f.slug = payment.slug;
                                    f.id = payment.id;
                                    f.uuid = payment.uuid;
                                    f.prix = payment.amount;
                                    f.date = moment(payment.date_payment).format('YYYY-MM-DD');
                                    f.date_facturation = moment(payment.date_facturation).format('YYYY-MM-DD');
                                    f.status = payment.statut;
                                    fArray.push(f);
                                }
                            }
                        }
                            
                });
                this.bills = fArray;
            },
        },

        methods:{
            onDeleteBillClick(payment) {
                let self = this;

                let args = {
                    payment: payment
                };

                let successMessage = this.$i18n.t('message.paymentDeleted');
                let errorMessages = {
                    generic: this.$i18n.t('message.genericError'),
                    error: this.$i18n.t('message.error')
                };

                this.$store.dispatch('deletePayment', { args, index: payment, successMessage, errorMessages })
                    .then(() => {
                        self.$bvModal.hide('delete-modal-' + payment);
                    });
            },
            onShowBillClick(uuid) {
                // <a :href="'/payment-prestation/'+order.uuid" target="_blank">
                Swal.fire({
                    title: 'Lien de paiment !',
                    icon: 'info',
                    html: `Lien de paiement de la prestation</b>, <a href="/payment-prestation/${uuid}" target="_blank">${window.location.origin}/payment-prestation/${uuid}</a> `
                })
            },
            onEditBillClick(id) {
                this.$router.push({ name: 'edit-pay-prestation', params: { id: id } });

            },
            getPayments(){
                let args = {
                    offset: this.offset,
                    limit: this.limit
                };

                this.$store.dispatch('getPayments', { args : args });                
            },

            handleOnAddBill() {
                this.$router.push({ name: 'add-pay-prestation' });
            },

            _handlePaginationClick(action) {
                this.paginationObject = handlePaginationClick(action, {...this.paginationObject});
            },

            billDate(date, type) {
                switch (type) {
                    case 'date': return moment(date).format('ddd, Do MMM YYYY');
                    case 'hour': return moment(date).format('HH:mm');
                }
            },

            getStatusClass(status) {
                if (status === 'NON PAYE' || status === 'Rejeter') return '--danger';
                else return '--success';
            },

            handlerOnFilterButton() {
                event.preventDefault();
                this.handleFilter(this.filterCriteria);
            },

            handleFilter(value) {
                if (value) {
                    const newBills = this.bills.filter(app => {
                        let result = false;

                        if (app.price) {
                            result = result || app.price.toLowerCase().includes(value.toLowerCase());
                        }

                        if (app.souscripteur) {
                            result = result || app.souscripteur.nom.toLowerCase().includes(value.toLowerCase());
                        }

                        if (app.billDate && this.billDate(app.billDate, 'date')) {
                            result = result || this.billDate(app.billDate, 'date').toLowerCase().includes(value.toLowerCase());
                        }

                        if (app.billDate && this.billDate(app.billDate, 'hour')) {
                            result = result || this.billDate(app.billDate, 'hour').toLowerCase().includes(value.toLowerCase());
                        }

                        return result;
                    });

                    this.paginationObject = pagination(newBills, 2);
                } else {
                    this.paginationObject = pagination(this.bills, 2);
                }
            },

			_displayNumber: displayNumber,
        },

        mounted() {
            this.getPayments();
        }
    }
</script>

<style scoped>

</style>
